import LoadingButton from "@mui/lab/LoadingButton"
import { Button, Checkbox, Dialog, OutlinedInput, DialogContent, DialogTitle, FormControl, Grid, InputLabel, ListItemText, MenuItem, Select, TextField, Autocomplete, Typography, Box } from "@mui/material"
import { useEffect, useState } from "react"
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useFieldArray, useForm } from "react-hook-form";
import api from './../../../../../../Apis'
import Swal from "sweetalert2";
import PostItemError from "./PostItemError";
import ListPostError from "./ListPostError";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import AddImage from "./AddImage";
import { useTranslation, Trans } from "react-i18next";
import DialogSelectFanpages from "./DialogSelectFanpages";
import DialogAttachmentManager from "../../../../../Globals/DialogAttachmentManager";
import { useNavigate } from "react-router-dom";

function Index(props) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [state, setState] = useState({
        loading_submit: false,
        dialog_post_error: false,
        list_post_errors: [],
        dialog: false,
        value_select: [],
        number_url: 1,
        time_post: 'now',
        dialog_file_manager: false,
        image_picked: [],
        // publish_type: ""
    })
    const [dialogFileManager, setDialogFileManager] = useState(false);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8; 
    const MenuProps = {
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          },
        },
    };
    const {register, handleSubmit, setValue, control, reset,  getValues} = useForm();
    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: "urls", // unique name for your Field Array
    });
    useEffect(() => {
        if (props.state.data_api?.list_post_errors && props.state.data_api.list_post_errors.length > 0) {
            setState({
                ...state,
                list_post_errors: props.state.data_api.list_post_errors
            })
        }
    }, [props.state.data_api?.list_post_errors])
    const handleChangeFanpage = (value) => {
        // console.log("runn", value);
        setState({
            ...state,
            value_select: value
        })
    };

    const base64Encode = (str) => {
        const bytes = new TextEncoder().encode(str); // UTF-8 encode
        let binary = '';
        bytes.forEach((b) => (binary += String.fromCharCode(b)));
        return btoa(binary); // base64 encode binary
    }

    const onCreateContent = (data) => {
        if (props.publish_type == "post") {
            publishPost(data);
        } else if (props.publish_type == "story") {
            publishStory(data);
        } else if (props.publish_type == "reels") {
            publishReels(data);
        }
    }

    const publishStory = (data) => {
        if (data.urls.length > 1) {
            Swal.fire(`${t('publish_post.publish_story_warning_1')}`, "", "warning");
            return;
        }
        if (data.urls.length == 0) {
            Swal.fire(`${t('publish_post.publish_story_warning_2')}`, "", "warning");
            return;
        }
        excutePublish(data, api.publish_story);
    }

    const publishReels = (data) => {
        if (data.urls.length > 1) {
            Swal.fire(`${t('publish_post.publish_reels_warning_1')}`, "", "warning");
            return;
        }
        if (data.urls.length == 0) {
            Swal.fire(`${t('publish_post.publish_reels_warning_2')}`, "", "warning");
            return;
        }
        excutePublish(data, api.publish_reels);
    }

    const excutePublish = (data, api_url) => {
        if (state.value_select == 0 && data.group_name == '') {
            Swal.fire({
                title: 'Cần chọn Fanpage hoặc nhóm page',
                icon: 'warning',
                timer: 1000
            })
            return;
        }
        setState({
            ...state,
            loading_submit: true
        })
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.cookie
            },
            body: JSON.stringify({
                fanpage_ids: state.value_select,
                urls: data.urls,
                process_name: data.process_name,
                group_id: data.group_name,
                lang: i18n.language,
                content: data.content ?? null
            })
        };
        fetch(api_url, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    setState({
                        ...state,
                        loading_submit: false,
                        dialog: false,
                        value_select: [],
                        number_url: 1,
                        image_picked: []
                    })
                    Swal.fire({
                        title: result.message,
                        icon: 'success',
                        timer: 1000
                    })
                    navigate("/dashboard/process")
                    reset();
                } else {
                    Swal.fire({
                        title: result.message,
                        text: result.error,
                        icon: 'error',
                        timer: 1000
                    })
                    setState({
                        ...state,
                        loading_submit: false
                    })
                }
            }
        )
    }

    const publishPost = (data) => {
        if (state.value_select == 0 && data.group_name == '') {
            Swal.fire({
                title: 'Cần chọn Fanpage hoặc nhóm page',
                icon: 'warning',
                timer: 1000
            })
            return;
        }
        setState({
            ...state,
            loading_submit: true
        })
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.cookie
            },
            body: JSON.stringify({
                fanpage_ids: state.value_select,
                content: base64Encode(data.content), // phải base 64 decode vì liên quan đến ký tự đặc biệt, khi gửi lên BE sẽ không nhận được
                urls: data.urls,
                type_time: data.type_time,
                hour: data.hour,
                minute: data.minute,
                date: data.date,
                group_id: data.group_name,
                process_name: data.process_name,
                lang: i18n.language
            })
        };
        fetch(api.create_post_unitest, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    setState({
                        ...state,
                        loading_submit: false,
                        dialog: false,
                        value_select: [],
                        number_url: 1,
                        time_post: 'now',
                        image_picked: []
                    })
                    Swal.fire({
                        title: result.message,
                        icon: 'success',
                        timer: 1000
                    })
                    // if (data.type_time == 'now') {
                    //     props.onCreateContent(result);
                    // }
                    navigate("/dashboard/process");
                    reset();
                } else {
                    Swal.fire({
                        title: result.message,
                        text: result.error,
                        icon: 'error',
                        timer: 1000
                    })
                    setState({
                        ...state,
                        loading_submit: false
                    })
                }
            }
        )
    }

    const removeElement = (index) => {
        // const image_picked_old = [...state.image_picked];
        // image_picked_old.splice(index, 1);
        const url_olds = getValues('urls');
        url_olds.splice(index, 1);
        setValue('urls', url_olds);
        setState({
            ...state,
            image_picked: url_olds
        })
        // const new_number_url = state.number_url - 1;

        // if (new_number_url > 0) {
        //     setState({
        //         ...state,
        //         number_url: state.number_url - 1
        //     })
        // }
    }

    const renderInput = () => {
        var i;
        var element = [];
        state.image_picked.map((value, i) => {
            setValue(`urls.${i}`, value);
            element.push(
            <Grid container spacing={2}>
                <Grid item xs={10}>
                    <TextField {...register(`urls.${i}`)} sx={{marginBottom: '15px'}} autoComplete="off" id="outlined-basic" size="small" fullWidth label={t("post.pasteImageLinkAtHere", {index : i})} variant="outlined" />
                </Grid>
                <Grid item xs={2}>
                    <Button onClick={() => removeElement(i)} variant="contained" color="error" size="medium">{t('common.delete')}</Button>
                </Grid>
            </Grid>)
        })
        // for (i = 1; i <= state.number_url; i++) {
        //     element.push(
        //     <Grid container spacing={2}>
        //         <Grid item xs={10}>
        //             <TextField {...register(`urls.${i}`)} sx={{marginBottom: '15px'}} autoComplete="off" id="outlined-basic" size="small" fullWidth label={"Dán link ảnh thứ " + i + ' tại đây'} variant="outlined" />
        //         </Grid>
        //         <Grid item xs={2}>
        //             <Button onClick={removeElement} variant="contained" color="error" size="medium">Xóa</Button>
        //         </Grid>
        //     </Grid>)
        // }

        return element;
    }

    const getHours = () => {
        const options = [];
        for (var hour = 0; hour <= 23; hour++) {
            options.push(
                <MenuItem value={hour}>{hour} {t("common.time.hour")}</MenuItem> 
            )
        }

        return options;
    }

    const getMinutes = () => {
        const options = [];
        for (var minute = 0; minute <= 59; minute++) {
            if (minute%5 == 0) {
                options.push(
                    <MenuItem value={minute}>{minute}  {t("common.time.minute")}</MenuItem> 
                )
            }
            
        }

        return options;
    }

    const updateImagePicked = (image_picked) => {
        const old_images = [...state.image_picked];
        const new_image_picked = old_images.concat(image_picked).map((item) => {
            if(item.url){
                return item.url
            }
            return item
        });
        // return
        const filterVideo = new_image_picked.filter((item) => item.includes(".mp4"));
        if (filterVideo.length > 0 && (new_image_picked.length != filterVideo.length || filterVideo.length > 1)) {
            Swal.fire(t("post.imageAndVideoNotAllowed"), "", "warning")
        } else {
            setState({
                ...state,
                image_picked: new_image_picked,
                // dialog_file_manager: false
            })
        }
    }

    const onChangeTimeCreatePost = (e) => {
        setState({
            ...state, time_post: e.target.value
        });
    }
    const date = new Date();
    const today = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate();
    const hour = date.getHours();
    const minute = 0;
    const list_fanpages = [
        // {fanpage_id: -1, name: t("common.all")},
        ...props.state.data_api?.fanpages
    ];

    const getTitle = () => {
        if (props.publish_type == "post") {
            return t("publish_post.add_post_button");
        } else if (props.publish_type == "story") {
            return t("publish_post.add_story_button");
        } else if (props.publish_type == "reels") {
            return "Đăng Reels";
        }
    }

    // console.log(props.state.fanpage_active, "dat123");
    // console.log(state.image_picked, "image_picked dat123");
    
    return (
        <>
            <Grid container direction={"column"} sx={{mt: -1, position: state.dialog_file_manager ? "fixed" : "static" }}

            >
                <Typography variant="h6" gutterBottom>
                    {getTitle()}
                </Typography>
                {/* <Button
                    sx={{marginRight: '10px'}} 
                    // startIcon={<AddRoundedIcon/>}
                    variant="text"
                    className="text-transform"
                    onClick={() => setState({...state, dialog: true, publish_type: "post"})}
                >{t("publish_post.add_post_button")}</Button>
                <Button
                    color="warning"
                    // sx={{marginRight: '10px'}} 
                    // startIcon={<AddRoundedIcon/>}
                    variant="text"
                    className="text-transform"
                    onClick={() => setState({...state, dialog: true, publish_type: "story"})}
                >{t("publish_post.add_story_button")}</Button>
                <Button
                    color="secondary"
                    // sx={{marginRight: '10px'}} 
                    // startIcon={<AddRoundedIcon/>}
                    variant="text"
                    className="text-transform"
                    onClick={() => setState({...state, dialog: true, publish_type: "reels"})}
                >{t("publish_post.add_reels")}</Button> */}
                {/* <ListPostError
                    total_post_error={props.state.data_api?.total_post_error}
                    cookie={props.cookie}
                /> */}
                {/* <Dialog
                    fullWidth="true"
                    maxWidth='lg'
                    open={state.dialog_file_manager}
                    onClose={() => setState({...state, dialog_file_manager: false})}
                >
                    <DialogTitle sx={{display: "flex", justifyContent: "space-between"}}>
                    {t('post.shopImages')}
                        <Button startIcon={<CloseOutlinedIcon />} variant="contained" color="warning" onClick={() => setState({...state, dialog_file_manager: false})}>
                            {t("common.close")}
                        </Button>
                    </DialogTitle>
                    <AddImage
                        updateImagePicked={updateImagePicked}
                        cookie={props.cookie}
                    />
                </Dialog> */}
            
                {/* <Dialog open={state.dialog} fullWidth="true" maxWidth='lg' onClose={() => {setState({...state, dialog: false, value_select: []})}}>
                    <DialogTitle>
                        {getTitle()}
                    </DialogTitle>
                    <DialogContent> */}
                        {
                            props.publish_type == "post" && (
                                <>
                                    <p>
                                        <Trans 
                                            i18nKey={"post.multiPostNotice"}
                                            components={{ b: <b style={{ color: 'red' }} /> }}
                                        />
                                    </p>
                                    <p>
                                        <Trans 
                                            i18nKey={"post.spinContentExample"}
                                            components={{ span: <span style={{ color: 'red' }} /> }}
                                        />
                                    </p>
                                </>
                            )
                        }
                        {
                            props.publish_type == "story" && (
                                <p>
                                    <b style={{color: "red"}}>Chú ý từ Facebook:</b> Nếu <b>Story</b> là video thì yêu cầu video có tỷ lệ <b>khung hình 9 x 16</b>, độ phân giải tối thiểu <b>540 x 960 pixel</b>, thời lượng từ <b>3 đến 90 giây</b>. Video nên được quay bằng điện thoại thì tỷ lệ phù hợp sẽ cao hơn.
                                </p>
                            )
                        }
                        {
                            props.publish_type == "reels" && (
                                <>
                                    <p>
                                        <b style={{color: "red"}}>Chú ý video khi đăng Reels:</b>
                                    </p>
                                    <p>
                                        <b>Loại file:</b> .mp4
                                    </p>
                                    <p>
                                        <b>Tỷ lệ khung hình:</b> 9 x 16
                                    </p>
                                    <p>
                                        <b>Độ phân giải: </b> 1080 x 1920 picel (khuyên dùng). Tối thiểu là 540 x 960 picel
                                    </p>
                                    <p>
                                        <b>Tốc độ khung hình: </b> 24 đến 60 khung hình/giây
                                    </p>
                                    <p>
                                        <b>Thời lượng:</b> 3 đến 90 giây. Thước phim được đăng dưới dạng tin trên Facebook không được vượt quá 60 giấy
                                    </p>
                                </>
                            )
                        }
                        <form onSubmit={handleSubmit(onCreateContent)}>
                            <Grid container spacing={2} sx={{paddingBottom: "16px"}}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth margin="dense" size="small">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                        }}>
                                            <DialogSelectFanpages fanpageSelected={state.value_select} listFanpages={list_fanpages} handleChangeFanpage={handleChangeFanpage} />
                                            <Typography color={"error"} >({state.value_select.filter((item) => item.fanpage_id !== -1).length}) {t("post.selectedFanpage")}</Typography>
                                        </Box>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField {...register('process_name')} required size="small" fullWidth id="outlined-basic" placeholder="Ví dụ: lần 1 05/07/2025" label={t("post.process_name")} variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                    <p className="m-t-0"><b>{t("post.selectPageGroup")}</b></p>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        fullWidth
                                        size="small"
                                        {...register('group_name')}
                                        MenuProps={MenuProps}
                                    >
                                        <MenuItem value="-1">{t("post.selectPageGroup")}</MenuItem>
                                        {
                                            props.group_pages.map((groupName, index) => {
                                                return (
                                                    <MenuItem key={index} value={groupName.id}>
                                                        <ListItemText primary={t("post.group") + " " + groupName.name} />
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </Grid>
                                {
                                    (props.publish_type == "post" || props.publish_type == "reels") && (
                                        <Grid item xs={12}>
                                            <textarea {...register("content")} placeholder={props.publish_type == "post" ? t('post.updateContentHere') : "Mô tả reels"} className="form-control" rows={15}></textarea>
                                        </Grid>
                                    )
                                }
                                
                                <Grid item xs={12}>
                                    <p className="t-right m-t-0">
                                        <Button onClick={() => setState({...state, dialog_file_manager: true})} type="button" className="text-transform" variant="contained" color="warning" startIcon={<AddRoundedIcon/>}>{t("post.addImageVideo")}</Button>
                                    </p>
                                    {renderInput()}
                                </Grid>
                                {
                                    props.publish_type == "post" && (
                                        <>
                                            <Grid item xs={12}>
                                                <p className="m-t-0"><b>{t('post.postingTime')}</b></p>
                                                <Select
                                                        labelId="demo-multiple-checkbox-label"
                                                        id="demo-multiple-checkbox"
                                                        fullWidth
                                                        size="small"
                                                        {...register('type_time')}
                                                        defaultValue={state.time_post}
                                                        onChange={onChangeTimeCreatePost}
                                                        MenuProps={MenuProps}
                                                    >
                                                        <MenuItem value="now">{t("post.immediately")}</MenuItem>
                                                        <MenuItem value="custom">{t('post.customize')}</MenuItem>
                                                </Select>
                                            </Grid>
                                            {
                                                state.time_post == 'custom' &&
                                                <Grid item xs={3}>
                                                    <Select
                                                        labelId="demo-multiple-checkbox-label"
                                                        id="demo-multiple-checkbox"
                                                        fullWidth
                                                        size="small"
                                                        defaultValue={hour}
                                                        {...register('hour')}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {getHours()}
                                                    </Select>
                                                </Grid>
                                            }
                                            {
                                                state.time_post == 'custom' &&
                                                <Grid item xs={3}>
                                                    <Select
                                                        labelId="demo-multiple-checkbox-label"
                                                        id="demo-multiple-checkbox"
                                                        fullWidth
                                                        size="small"
                                                        defaultValue={minute}
                                                        {...register('minute')}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {getMinutes()}
                                                    </Select>
                                                </Grid>
                                            }
                                            {
                                                state.time_post == 'custom' &&
                                                <Grid item xs={6}>
                                                    <TextField type="date" {...register('date')} defaultValue={today} fullWidth size="small" id="outlined-basic" label={t("common.dateTime.day")} variant="outlined" InputLabelProps={{
                                                        shrink: true
                                                    }} />
                                                </Grid>
                                            }
                                            <Grid item xs={12}>
                                                <p className="m-t-0">{t("post.personalize")}:</p>
                                                <ul>
                                                    <li>
                                                        {"{page_name}"}: {t("post.pageName")}
                                                    </li>
                                                </ul>
                                            </Grid>
                                        </>
                                    )
                                }
                                
                                <Grid item xs={12}>
                                    <LoadingButton className="text-transform" type="submit" size="large" fullWidth loading={state.loading_submit} variant="contained">
                                        {t("common.confirm")}
                                    </LoadingButton>
                                    {/* <Button className="text-transform" type="submit" size="large" fullWidth variant="contained">
                                        {t("common.confirm")}
                                    </Button> */}
                                </Grid>
                            </Grid>
                        </form>
                    {/* </DialogContent>
                </Dialog> */}
                 <DialogAttachmentManager
                    isOpenDialogAttachment={state.dialog_file_manager}
                    closeDialogAttachment={() => setState(prev => ({...prev, dialog_file_manager: false}))}
                    cookie={props.cookie}
                    fanpage_id={props.state.fanpage_active}
                    page_name="posts"
                    imageSelectedOld={[]}
                    imagePicked={updateImagePicked}
                />
            </Grid>
            {/* <Dialog
                    fullWidth="true"
                    maxWidth='lg'
                    open={state.dialog_file_manager}
                    onClose={() => setState({...state, dialog_file_manager: false})}
                >  */}
                {/* <Button onClick={() => setState({...state, dialog_file_manager: true})} type="button" className="text-transform" variant="contained" color="warning" startIcon={<AddRoundedIcon/>}>{t("post.addImageVideo")}</Button> */}
                    
                {/* </Dialog> */}
        </>
    )
}

export default Index;